export const AUTH_TYPE = {
  LOGIN: { step: "login", title: "כניסת משתמשים רשומים" },
  RECOVER_PASSWORD: { step: "recover-password", title: "שחזור סיסמה קיימת" },
  RESET_PASSWORD: { step: "reset-password", title: "יצירת סיסמה אישית" },
  REGISTER: { step: "register", title: "הרשמה לאתר" },
  REG_PROMO: { step: "regPromo", title: "מישהו חשב עליך!" },
  REG_SUCCESS: { step: "regSuccess", title: "נרשמת בהצלחה!" },
};
